module.exports = __webpack_public_path__ + "static/media/logo_emv.473f07b0.svg";